import React, { useState, useEffect } from "react";
import secureLocalStorage from "react-secure-storage";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
// import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import fire1 from "../../assets/images/dasboard/fireac.webp";
import axios from "axios";
import logo from "../../assets/images/logo.png";
import API_BASE_URL from "../../config/ApisCollection";
import { useLocation } from "react-router-dom";
import Error from "../../components/Error";
import discovercardicon from "../../assets/images/paymentcards/discover.png";
import jcbcardicon from "../../assets/images/paymentcards/jcb.png";
import maestrocardicon from "../../assets/images/paymentcards/maestro.png";
import mastercardicon from "../../assets/images/paymentcards/master-card.png";
import paypalcardicon from "../../assets/images/paymentcards/paypal.png";
import visacardicon from "../../assets/images/paymentcards/visa.png";

const PricePlan = () => {
  const Allimages = [];
  const location = useLocation();
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("");

  const weightlet = secureLocalStorage.getItem("weightGoal");
  const accessToken = secureLocalStorage.getItem("accessToken");
  // console.log(location.state);
  let currentURL = window.location.href;
  var url = new URL(currentURL);
  var baseUrl =
    url.protocol + "//" + url.hostname + (url.port ? ":" + url.port : "");
  let finalData = location?.state;

  const filteredItems = finalData;
  const currency_symbols = { usd: "$", gbp: "£", cad: "$", aud: "$" };
  // console.log(filteredItems);

  const handleSelectPlan = (plan) => {
    setSelectedPlan(plan);
    setIsPopUpOpen(true);
  };
  // console.log(selectedPlan);
  // console.log(baseUrl);
  const PayGlocalHandle = async (event) => {
    // setIsPgProcessing(true);

    secureLocalStorage.setItem("planData", selectedPlan);
    secureLocalStorage.setItem("gateway", event);
    let getway_api = "";

    if (event === "stickypaypal") {
      getway_api = API_BASE_URL + "/pro/payment/stk/log/paypaloptioninitiate";
    } else if (event === "linkq") {
      getway_api = API_BASE_URL + "/pro/p4/linkq/initiate";
    } else if (event === "stripe") {
      getway_api = API_BASE_URL + "/pro/p6/strp/initiate";
    } else {
      getway_api = API_BASE_URL + "/pro/p3/pg/initiate";
    }

    let planid = selectedPlan.id;
    const postOption = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify({
        planId: planid,
        callback: baseUrl + "/callback/pg/" + event,
      }),
    };
    fetch(getway_api, postOption)
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          console.log(result.redirectUrl);
          window.location.href = result.redirectUrl;
          // setIsPgProcessing(false);
        } else if (result.error) {
          alert(result.error.message);
          // setIsPgProcessing(false);
        }
      })
      .catch((err) => {
        // setIsPgProcessing(false);
        console.log(err);
      });
  };

  return (
    <div navbar={2} body_position={"top"} className="bg-[#fffcfb]">
      {finalData ? (
        <>
          <div className="logo flex justify-center top-0 z-30 fixed py-5 w-full bg-[#fffcfb] undefined">
            <img
              loading="lazy"
              src={logo}
              alt="logo"
              className="h-auto w-[100px] z-30"
              width="100"
              height="30"
            />
          </div>

          <div className="bodyly mt-16 max-w-[620px]  main-bodly pt-1">
            <div className="flex items-center ">
              <div className="w-full mb-14 text-center">
                <h1 className="malestar1 mt-9">
                  <span className="sm:text-3xl text-2xl title">
                    Let’s begin your{" "}
                  </span>
                  <span className="sm:text-3xl text-2xl titlecolo">
                    weight loss
                  </span>
                  <span className="sm:text-3xl text-2xl title"> journey</span>
                </h1>

                <div className="plnaebase h-[250px] text-center ">
                  <div className="dis topsc">
                    <p className="text-5xl font-medium">
                      {filteredItems?.caseStudy?.targetWeight}{" "}
                      {filteredItems?.caseStudy?.weightType}
                    </p>
                  </div>

                  <p className="font-medium text-sm mt-2 opacity-100 text-center">
                    {" "}
                    {/* {filteredItems.achive_date} */}
                    {
                      filteredItems?.caseStudy?.kb_monthly_result
                        ?.expected_result
                    }
                  </p>
                </div>
                <div className="pricedemo flex justify-center w-full gap-10 lg:flex-row flex-col lg:absolute left-0 mt-10">
                  {finalData?.plan?.map((item, index) => {
                    return (
                      <div
                        className={`max-w-[380px] w-full cursor-pointer text-center  border p-2  rounded-3xl ${
                          item?.name == selectedPlan?.name
                            ? "border-[#ff9950] bg-[#FEF8F4]"
                            : "bg-white border-[#f3f4f6]"
                        }`}
                        onClick={() => handleSelectPlan(item)}
                        key={index}
                      >
                        <div className="thankboxtop">
                          <div className="flex items-center gap-1 min-w-[230px]">
                            <div
                              className={`${
                                item?.name == selectedPlan?.name
                                  ? "bg-gradient-to-r from-[#fffffff0] to-[#fe7701]"
                                  : "bg-[#FFEDE0]"
                              } thankboxico rounded-circle sm:max-w-12 sm:w-full sm:h-12 max-w-8 w-full h-8 flex items-center justify-between`}
                            >
                              <img
                                loading="lazy"
                                src={fire1}
                                alt="fire1"
                                className="thankboxiconim p-0 sm:w-6 w-3"
                              />
                            </div>
                            <div className="text-left ml-2">
                              <p className="text-xl font-semibold">
                                {item?.name}
                              </p>
                              <p className="text-xs font-normal">
                                {item?.subTitle}
                              </p>
                            </div>
                          </div>
                          <div className="thankboxdis w-auto bg-[#8BC34A]">
                            <p className="text-xs text-white">
                              {Math.round(
                                ((item?.price - item?.credits) / item?.price) *
                                  100
                              )}
                              % off
                            </p>
                          </div>
                        </div>
                        <div className="thankboxpric1 border border-gray-100 rounded-2xl mt-2">
                          <div className="thankboxprictexlay justify-center gap-3  ">
                            <span className="thankboxprictexmn text-base text-gray-400 !font-[work-sans-medium]">
                              $ {item?.price}
                            </span>
                            <span className="thankboxprictex text-xl !font-[work-sans-bold]">
                              $ {item?.credits}
                            </span>
                          </div>
                        </div>
                        <p className="text-sm font-medium mt-2">
                          only ${item?.pricePerWeek} {item?.titlePerWeekDay}
                        </p>
                      </div>
                    );
                  })}
                </div>

                <div
                  className={
                    "fixed bottom-10 w-full items-center right-0 left-0 text-center"
                  }
                >
                  <button
                    label={"Buy Now"}
                    className={
                      " bottonly text-2xl bg-gray-300 sm:py-2 py-1 rounded-2xl w-[290px] min-h-[60px] tracking-wider	 text-white bottonlyac !bg-[#ff9950]"
                    }
                    onClick={() => handleSelectPlan(finalData?.plan[0])}
                  >
                    {" "}
                    Buy Now
                  </button>
                </div>
              </div>
            </div>
          </div>

          <Popup
            open={isPopUpOpen}
            position="center"
            className="pop-price"
            onClose={() => setIsPopUpOpen(false)}
          >
            <div className="content py-2 p-2">
              <div className="df spallpopam mb-2  justify-between">
                <div className="poptit text-lg font-medium">
                  Select payment method
                </div>
                <div
                  className="closeicobthak text-sm cursor-pointer  font-medium text-orange"
                  onClick={() => setIsPopUpOpen(false)}
                >
                  ← Back to Plans
                </div>
              </div>
              <div className="bg-[#ebebeb] h-[2px] w-full my-5"></div>
              <div className="df mt-2">
                <table
                  style={{ borderBottom: "1px solid #d1d1d1", width: "100%" }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{ textAlign: "left" }}
                        className="text-base font-medium"
                        id="ketocntid"
                      >
                        {selectedPlan?.name}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <del style={{ color: "#5bb05a" }} id="mrpid">
                          {currency_symbols["us"]}${selectedPlan?.price}
                        </del>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{ textAlign: "left" }}
                        className="text-base font-medium"
                        id="disid"
                      >
                        Discount - (
                        {Math.round(
                          ((selectedPlan?.price - selectedPlan?.credits) /
                            selectedPlan?.price) *
                            100
                        )}
                        %)
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <b style={{ color: "#5bb05a" }} id="idmonth">
                          {currency_symbols["us"]}$
                          {(
                            selectedPlan?.price - selectedPlan?.credits
                          ).toFixed(2)}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{ textAlign: "left" }}
                        className="text-base font-medium"
                      >
                        Total{" "}
                      </td>
                      <td
                        style={{ textAlign: "right" }}
                        className="amount"
                        id="idprice"
                      >
                        <b>
                          {currency_symbols["us"]}${selectedPlan?.credits}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="grid grid-cols-1 justify-items-center gap-2 mt-2 py-10">
                {[
                  {
                    key: "payglocal",
                    label: "Debit or Credit Card",
                    color: "bg-[#ff9950]",
                    handler: "payglocal",
                  },
                  {
                    key: "linkq",
                    label: "Debit or Credit Card",
                    color: "bg-[#ff9950]",
                    handler: "linkq",
                  },
                  {
                    key: "stripe",
                    label: "Payment by Stripe",
                    color: "bg-[#ff9950]",
                    handler: "stripe",
                  },
                  {
                    key: "stickypaypal",
                    label: "Pay with PayPal",
                    color: "bg-[#ff9950]",
                    handler: "stickypaypal",
                  },
                ]
                  ?.filter((option) => finalData?.paymentList?.[option.key])
                  .map((option, index) => (
                    <div
                      key={option.key}
                      className={` w-full px-10 py-2 text-white rounded-[5px] cursor-pointer text-center text-[19px] leading-normal  ${option.color} hover:bg-[#5bb05a]`}
                      onClick={() => PayGlocalHandle(option.handler)}
                    >
                      {option.label}
                    </div>
                  ))}
              </div>

              <div className="bg-[#ebebeb] h-[2px] w-full my-5"></div>
              <div className="flex justify-center gap-3 mt-2">
                {[
                  paypalcardicon,
                  discovercardicon,
                  maestrocardicon,
                  mastercardicon,
                  visacardicon,
                  jcbcardicon,
                ]?.map((card_item, index) => {
                  return (
                    <img
                      src={card_item}
                      className="sm:w-w-10 w-10"
                      alt="visa"
                      key={index}
                    />
                  );
                })}
              </div>
            </div>
          </Popup>
        </>
      ) : (
        <Error errorMessage={""} />
      )}
    </div>
  );
};
export default PricePlan;
